import * as S from "./styled";

export default S.Flex;
